<div class="container pt-2 pb-2">
    TERM OF USE
 </div>